import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class NativeFeatureHeroGrid extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.bannerImageDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (bannerDetail === undefined) {
      return null;
    }

    const leftImage = bannerDetail.map((bannerimagedetails, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      if (bannerimagedetails.imagePosition === 'left') {
        return (
          <a
            href={bannerimagedetails.bannerUrlLink}
            key={i}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} className="img-animate" />
          </a>
        );
      }
    });
    const gridtopleft = bannerDetail.map((bannerimagedetails, j) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      if (bannerimagedetails.imagePosition === 'gridtopleft') {
        return (
          <a
            href={bannerimagedetails.bannerUrlLink}
            key={j}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} className="img-animate" />
          </a>
        );
      }
    });
    const gridtopRight = bannerDetail.map((bannerimagedetails, k) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      if (bannerimagedetails.imagePosition === 'gridtopRight') {
        return (
          <a
            href={bannerimagedetails.bannerUrlLink}
            key={k}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} className="img-animate" />
          </a>
        );
      }
    });
    const gridbottomLeft = bannerDetail.map((bannerimagedetails, l) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      if (bannerimagedetails.imagePosition === 'gridbottomLeft') {
        return (
          <a
            href={bannerimagedetails.bannerUrlLink}
            key={l}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} className="img-animate" />
          </a>
        );
      }
    });
    const gridbottomRight = bannerDetail.map((bannerimagedetails, m) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      if (bannerimagedetails.imagePosition === 'gridbottomRight') {
        return (
          <a
            href={bannerimagedetails.bannerUrlLink}
            key={m}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} className="img-animate" />
          </a>
        );
      }
    });
    const rightImage = bannerDetail.map((bannerimagedetails, n) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      if (bannerimagedetails.imagePosition === 'Right') {
        return (
          <a
            href={bannerimagedetails.bannerUrlLink}
            key={n}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} className="img-animate" />
          </a>
        );
      }
    });

    return (
      <div className="gallery-com row">
        <Col xs={5} className="left-image">
          {leftImage}
        </Col>
        <Col xs={4} className="middle-image row">
          <Col xs={6}>{gridtopleft}</Col>
          <Col xs={6}>{gridtopRight}</Col>
          <Col xs={6}>{gridbottomLeft}</Col>
          <Col xs={6}>{gridbottomRight}</Col>
        </Col>
        <Col xs={3} className="right-image">
          {rightImage}
        </Col>
      </div>
    );
  }
}

export default BannerWrapper(NativeFeatureHeroGrid);
